<template>
    <div class="upload_div">
        <el-dropdown
            icon="el-icon-bottom"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            style="margin-left: 10px"
            @command="handleUpload"
            :disabled="upload_disable"
        >
            <el-button type="primary"> {{ name }} <i class="el-icon-arrow-down el-icon--right"></i> </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-bottom" command="downLoadInsertTemp" v-if="display_insert">下载模板</el-dropdown-item>
                <el-dropdown-item icon="el-icon-upload" v-if="display_insert">
                    <el-upload
                        ref="uploadInsert"
                        style="display: inline-block"
                        :limit="1"
                        action
                        name="file"
                        :auto-upload="true"
                        list-type="picture"
                        :show-file-list="false"
                        :http-request="uploadInsert"
                        accept=".csv"
                    >
                        批量引入
                    </el-upload>
                </el-dropdown-item>
                <el-dropdown-item icon="el-icon-bottom" command="downLoadUpdateTemp" v-if="display_update">更新模板</el-dropdown-item>
                <el-dropdown-item icon="el-icon-upload" v-if="display_update">
                    <el-upload
                        ref="uploadUpdate"
                        style="display: inline-block"
                        :limit="1"
                        action
                        name="file"
                        :auto-upload="true"
                        list-type="picture"
                        :show-file-list="false"
                        :http-request="uploadUpdate"
                        accept=".csv"
                    >
                        批量更新
                    </el-upload>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
export default {
    name: 'k3Upload',
    props: {
        obj: {
            type: String
        },
        display_insert: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            default: '引入'
        },
        display_update: {
            type: Boolean,
            default: false
        },
        token: {
            type: String
        }
    },
    data() {
        return {
            upload_disable: false,
            loading: false
        };
    },
    watch: {},
    methods: {
        uploadInsert(param) {
            this.onUpload('insert', param, this.$refs.uploadInsert);
        },
        uploadUpdate(param) {
            this.onUpload('update', param, this.$refs.uploadUpdate);
        },
        handleUpload(command) {
            if (command == 'downLoadInsertTemp') {
                this.onDownTemplate('insert');
            } else if (command == 'downLoadUpdateTemp') {
                this.onDownTemplate('update');
            }
        },
        onDownTemplate(type) {
            this.upload_disable = true;
            this.loading = true;

            let method = 'downloadK3InsertTemplate';

            if (type == 'update') {
                method = 'downloadK3UpdateTemplate';
            }

            this.$api[method]({
                obj: this.obj,
                upload_token: this.token
            })
                .then((res) => {
                    this.$message({
                        message: '下载成功!',
                        type: 'success'
                    });
                    this.upload_disable = false;
                    this.loading = false;
                })
                .catch((error) => {
                    this.upload_disable = false;
                    this.loading = false;
                });

            return true;
        },
        onUpload(type, param, uploadObject) {
            this.upload_disable = true;
            this.loading = true;

            let method = 'uploadK3Insert';

            if (type == 'update') {
                method = 'uploadK3Update';
            }

            var fileObj = param.file;
            let fileData = new FormData(); // FormData 对象
            fileData.append('file', fileObj); // 文件对象
            fileData.append('obj', this.obj);
            fileData.append('upload_token', this.token);
            this.$api[method](fileData)
                .then((res) => {
                    uploadObject.clearFiles();

                    if (res.data.length == 0) {
                        this.$message.success('上传成功');
                    } else {
                        this.$confirm('存在上传失败的数据，是否导出错误？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            closeOnPressEscape: false,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                res.data.upload_token = this.token;

                                this.$api
                                    .downloadK3ErrorMessage(res.data)
                                    .then((r) => {
                                        this.$message.success('下载成功');
                                    })
                                    .catch((e) => {});
                            })
                            .catch(() => {});
                    }

                    this.upload_disable = false;
                    this.loading = false;
                })
                .catch((error) => {
                    uploadObject.clearFiles();
                    this.upload_disable = false;
                    this.loading = false;
                });
        }
    }
};
</script>

<style>
.upload_div .el-loading-spinner {
    top: 90% !important;
}
</style>